import { useQuery } from '@tanstack/react-query';
import { Box, Stack } from '@mui/material';
import { useApiClient, useHasPermission } from '@@common';
import { ActivityMetadataModel, AgentClient } from '../../../../api/api';
import { Permissions } from '../../../../common/Permissions';
import AgentAvatar from '../../../Agents/AgentAvatar';
import { ActivityModel } from '../../Models/FlowModel';
import ActivityIcon from '../ActivityIcon';
import DisplayContentTemplate from '../DisplayContentTemplate';

export default function AgentActivityNodeContent({ agentId, activity, metadata }: { agentId?: string; activity: ActivityModel; metadata?: ActivityMetadataModel }) {
	const client = useApiClient(AgentClient);
	const canReadAgents = useHasPermission(Permissions.AgentRead);
	const { data: agent } = useQuery({
		queryKey: ['agent-picker-by-id', agentId?.toLowerCase()],
		queryFn: () => client.getAgent(agentId!),
		enabled: canReadAgents && !!agentId,
		staleTime: 60_000,
		retry: false,
	});
	return <Stack className="agent-activity-content" direction="row" alignItems="center" spacing={2} sx={{ position: 'absolute', inset: 0, pr: 1, minWidth: 0, boxSizing: 'border-box', borderRadius: 'inherit', overflow: 'hidden' }}>
		<Box className="agent-activity-portrait" sx={{ flexShrink: 0, width: 80, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', '& > .MuiAvatar-root': { width: '100%', height: '100%', m: 0, borderRadius: 0, '& img': { objectFit: 'cover', objectPosition: 'center' } } }}>
			{canReadAgents && agent?.fileId
				? <AgentAvatar name={agent.name} fileId={agent.fileId} size={80} cutout />
				: <Box className="agent-activity-fallback-icon" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 20, height: 20, flexShrink: 0, transform: 'scale(2.4)', transformOrigin: 'center' }}>
					<ActivityIcon activityMetadata={metadata} maxWidth="20px" />
				</Box>}
		</Box>
		<Box sx={{ flex: 1, minWidth: 0 }}>
			<DisplayContentTemplate template={metadata?.displayContent} fallbackText={(canReadAgents ? agent?.name : undefined) ?? metadata?.displayName ?? activity.Type} context={activity} className="label" />
		</Box>
	</Stack>;
}
